export const cssrs_catalog = [
    "1. ¿Ha deseado estar muerto(a) o poder dormirse y no despertar? ",
    "2. ¿Ha tenido realmente la idea de suicidarse? ",
    "3. ¿Ha pensado en cómo llevaría esto a cabo? ",
    "4. ¿Ha tenido estas ideas y en cierto grado la intención de llevarlas a cabo? ",
    "5) ¿Ha comenzado a elaborar o ha elaborado los detalles sobre cómo suicidarse? ¿Tenída intenciones de llevar a cabo este plan? ",
    "6) ¿Ha hecho algo usted, comenzado a hacer algo o se has preparado para hacer algo para terminar su vida? ",
]